export default __webpack_public_path__ + "img/broulims-plus.png";